import React, { ReactNode } from "react";
import { useIsSmallScreen } from "../../App";

export const TextLine: React.FC<{
    indent?: number;
    children: ReactNode;
}> = (props) => {
    const { children, indent } = props;

    const isSmallScreen = useIsSmallScreen();

    return (
        <div
            style={{
                paddingLeft:
                    indent === 10
                        ? 0
                        : (indent ?? 0) * (isSmallScreen ? 16 : 24),
                paddingTop: (indent ?? 0) === 0 ? 6 : 0,
                paddingBottom: (indent ?? 0) === 0 ? 6 : 0,
                textAlign:
                    indent === 10
                        ? "right"
                        : (indent ?? 0) === 0
                        ? "justify"
                        : "left",
            }}
        >
            {children}
        </div>
    );
};
